export default {"src":"/_next/static/media/baseball.46491cd8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};